import useSWR from "swr";
import axios from "../../config/AxiosConfig";
import { GET_CRYPTO_TO_USD_PRICE_API } from "../../store/actions/apiCollections";

export const getPriceFecture = (url) =>
  axios.get(url).then((res) => res.data.data);

export const useGetPrice = () => {
  const { data, error, mutate, isLoading, isValidating } = useSWR(
    GET_CRYPTO_TO_USD_PRICE_API,
    getPriceFecture,
    {
      keepPreviousData: true,
      revalidateOnFocus: true,
      revalidateOnMount: true,
    }
  );

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
